<template>
  <div class="activity-wrap">
    <div id="app" v-cloak class="main">
      <section class="mod">
        <div class="card flex">
          <div class="item">
            <div class="content flex">
              <div>
                <sub>¥</sub>
                <span>1980</span>
                <sub>/年</sub>
              </div>
              <div>
                <em>大智慧专业版</em>
                <i>原价<b>2680元</b>/年</i>
              </div>
            </div>
            <div class="btn" @click="buy(73)">省¥700&nbsp;&nbsp;&nbsp;&nbsp;立即抢购></div>
          </div>
        </div>
      </section>
      <section class="mod">
        <div class="mod-title">大智慧专业版</div>
        <div class="mod-info">包含大智慧「365」全部功能+自设股票池+超赢实时监控+超赢思维+机构去哪儿+董秘爆料+热点狙击+主动资金+竞价洞察等高端炒股功能。</div>
        <div class="mod-banner">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div>
                <div class="mod-banner-title">
                  <span>机构去哪儿</span>
                  <em>紧跟机构脚步</em>
                </div>
                <img src="../../assets/images/activity/activity20250301/pic-03.jpg">
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="mod">
        <div class="mod-title">大智慧专业版</div>
        <div class="mod-info">包含大智慧「365」全部功能+自设股票池+超赢实时监控+超赢思维+机构去哪儿+董秘爆料+热点狙击+主动资金+竞价洞察等高端炒股功能。</div>
        <div class="mod-banner">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div>
                <div class="mod-banner-title">
                  <span>自设股票池</span>
                  <em>自定义条件优选牛股</em>
                </div>
                <img src="../../assets/images/activity/activity20250301/pic-04.jpg">
              </div>
            </div>
          </div>
        </div>
        <div class="mod-btn" @click="buy(73)"><span>只需<em>1980</em>元，立即抢购></span><i>立省700元</i></div>
        <div class="mod-agreement">已经阅读并同意<a href="###" ><router-link to="/protocol" target="_blank">《使用软件产品许可协议》</router-link></a></div>
      </section>
      <div class="tips">风险提示：本产品不涉及投资咨询及投资顾问服务，所展示信息不构成投资建议；数据基于历史，不代表未来趋势；所有工具都有局限性，适合不同<br>情况下的市场，仅供参考，请理性投资，控制风险，投资有风险，入市需谨慎。</div>
      <div class="popup" style="display: none;" v-show="this.showPage">
        <!-- 购买产品弹窗 -->
        <div class="popup-main gmcp"  v-show="this.buyPage">
          <div class="close" @click="closePage('buyPage')"></div>
          <div class="title">
            <span>购买产品：</span>
            <em>1年</em>
            <b>大智慧「专业版」</b>
          </div>
          <div class="qrcode">
            <qriously :value="qrData" :size="260" level="M"  v-show="qrData"/>
          </div>
          <div class="tabs">
            <div class="item" :class="selectPayMode== 23 ? 'active':''">
              <div @click="changePayMode(23)"><i class="icon-wx"></i><span>微信支付</span></div>
            </div>
            <div class="item" :class="selectPayMode== 29 ? 'active':''">
              <div @click="changePayMode(29)"><i class="icon-zfb"></i><span>支付宝</span></div>
            </div>
            <div class="item" :class="selectPayMode== 0 ? 'active':''">
              <div @click="changePayMode(0)"><i class="icon-qtzf"></i><span>其他支付</span></div>
            </div>
          </div>
          <div class="foot">
            <!-- 支付金额 -->
            <div class="zfje">
              <span>支付金额</span>
              <sub>¥</sub>
              <em>1980</em>
              <b>¥2680</b>
              <i>已减700元</i>
            </div>
            <!-- 许可协议 -->
            <div class="xkxy">
              <span>已经阅读并同意</span>
              <a href="###" ><router-link to="/protocol" target="_blank">《使用软件产品许可协议》</router-link></a>
            </div>
            <!-- 发票信息 -->
            <div class="fpxx">
              发票信息：电子普通发票 
            <span v-if="this.invoiceTitleType == 1">个人</span>
            <span v-else>单位</span>
            信息技术服务 <a @click="openInvoice">发票填开></a>
            </div>
          </div>
        </div>
        <!-- 支付成功弹窗 -->
        <div class="popup-main zfcg" v-show="this.successPage">
          <div class="close" @click="closePage('successPage')"></div>
          <div class="icon"></div>
          <div class="text">支付成功</div>
          <div class="btns" @click="closePage('successPage')"><span>好的</span></div>
        </div>
        <!-- 继续支付弹窗 -->
        <div class="popup-main jxzf" v-show="this.retainPage">
          <div class="text">订单已生成，还差一步</div>
          <div class="info">即可开通大智慧「专业版」<br>确定放弃购买吗？</div>
          <div class="btns">
            <span @click="closePage('abandonPage')">忍痛放弃</span>
            <span @click="closePage('retainPage')">继续支付</span>
          </div>
        </div>
      </div>
      <!-- 电子发票组件 -->
      <invoice @saveInvoiceTitleType="changeInvoiceTitleType" ref="invoice" />
    </div>
  </div>
</template>
<script>
import Invoice from "@/components/invoice/Invoice.vue";
export default {
  components: {
    Invoice
  },
  data() {
    return {
      showPage:false,
      buyPage:false,
      successPage: false,
      retainPage: false,
      selectPayMode: 23,
      qrData:'qrData',
      orderId: '',
      invoiceTitleType:1,
      s: this.$route.query.s,
    }
  },
  watch: {
  },
  created() {
    if(!this.s){
      this.s = "";
    };
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    buy(productId){
      this.selectPayMode = 23;
      this.saveOrder(productId)
      this.showPage = true
      this.buyPage = true;
    },
    closePage(pageName){
      if(pageName == 'buyPage'){
        this.retainPage = true;
      }else if(pageName == 'successPage'){
        this.successPage = false;
        this.showPage = false;
      }else if(pageName == 'retainPage'){
        this.retainPage = false;
        this.buyPage = true;
      }else if(pageName == 'abandonPage'){
        this.retainPage = false;
        this.buyPage = false;
        this.successPage = false;
        this.showPage = false
        clearInterval(this.orderStatusTimer)
      }
    },
    changePayMode(payMode) {
      if(payMode == 0){
        clearInterval(this.orderStatusTimer)
        var routerDate = this.$router.resolve({name: 'OrderPay', params:{orderId: this.orderId}})
        let href = routerDate.href
        window.location.href = href
      }else{
        this.selectPayMode = payMode;
        this.getQrCode(this.orderId,this.selectPayMode)
      }
    },
    getQrCode(orderId,selectPayMode) {
      if (this.lock) {
        return false;
      }
      var params = {
        id: orderId,
        payMode: selectPayMode
      };
      this.lock = true;
      this.$get("/pay/qrcode", params)
        .then(response => {
          if (response.code === 0) {
            this.qrData = response.data;
            if (selectPayMode == 29) {
              this.aliPayQrCode = this.qrData;
            }
            if (selectPayMode == 23) {
              this.wechatPayQrCode = this.qrData;
            }
            
          }
          this.lock = false;
        })
        .catch(err => {
          this.qrData = '';
          this.lock = false;
        });
    },

    saveOrder(selectProductId){
      var activityParam = {
        productId: selectProductId,
        monthCount: 12
      }
      this.$post("/order/activityBuying", activityParam)
            .then(response => {
              if (response.code === 0) {
                this.orderId = response.data.id;
                this.lastInvoiceTitleType = response.data.invoiceTitleType;
                this.invoiceTitleType = response.data.invoiceTitleType;
                this.getQrCode(this.orderId,this.selectPayMode)
                this.getOrderStatusTimer(this.orderId)
              } else if (response.code === 203) {
                this.$global.alert(response.msg);
                this.showPage = false
                this.buyPage = false;
                this.successPage = false;
                this.retainPage = false;
              }else{
                var params = {
                  productId: selectProductId,
                  monthCount: 12,
                  orderType: 0,
                  convertMoney: 0,
                  invoiceTitleType: 1,
                  questionsId: "0",
                  buySource: this.s
                };
                this.$post("/order/save", params)
                  .then(response => {
                    if (response.code === 0) {
                      this.orderId = response.data.id;
                      this.getQrCode(this.orderId,this.selectPayMode)
                      this.getOrderStatusTimer(this.orderId)
                    } else {
                      this.$global.alert(response.msg);
                      this.showPage = false;
                      this.buyPage = false;
                      this.successPage = false;
                      this.retainPage = false;
                    }
                  })
                  .catch(err => {
                    this.$global.alertError();
                  });
              }
            })
            .catch(err => {
              this.$global.alertError();
            });
    },

    getOrderStatusTimer() {
      var count = 60;
      this.orderStatusTimer = setInterval(() => {
        if (count <= 0) {
          clearInterval(this.orderStatusTimer);
        } else {
          count--;
          this.$get("/order/status?id=" + this.orderId).then(response => {
            if (response.code === 0 && (response.data == 1 || response.data == 9)) {
              this.buyPage = false;
              this.successPage = true;
              this.retainPage = false;
              this.orderId = '';
              clearInterval(this.orderStatusTimer)
            }
          });
        }
      }, 5000);
    },

    openInvoice() {
      //调用子组件发票抬头类型
      this.$refs.invoice.openInvoice();
    },
    changeInvoiceTitleType(invoiceTitleType) {
      //获取发票组件发票抬头类型
      this.invoiceTitleType = invoiceTitleType;
      if(this.invoiceTitleType !== this.lastInvoiceTitleType){
        this.lastInvoiceTitleType = this.invoiceTitleType;
        this.updatePaymentInvoiceTitleType()
      }
    },
    updatePaymentInvoiceTitleType(){
      this.$get("/order/updateInvoiceTitleType?orderId=" + this.orderId + "&invoiceTitleType=" + this.invoiceTitleType)
        .then(response => {
          if (response.code !== 0) {
            this.alert(response.msg)
          }
      })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
    },
  }
};
</script>

<style type="text/css" scoped>
body,
div,
span,
header,
footer,
nav,
section,
aside,
article,
ul,
dl,
dt,
dd,
li,
a,
p,
h1,
h2,
h3,
h4,
h5,
h6,
i,
b,
em,
strong,
th,
td,
textarea,
button,
input,
select,
figure,
figcaption {
  padding: 0;
  margin: 0;
  font-style: normal;
  font-weight: normal;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: none;
  -ms-text-size-adjust: none;
  text-size-adjust: none;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

html {
  background-color: #fff9f1;
}

body {
  font-family: PingFangSC-Regular, Helvetica, Tahoma, Arial, "Microsoft YaHei", "Hiragino Sans GB", "WenQuanYi Micro Hei", sans-serif;
  font-size: 14px;
  min-width: 750px;
  min-height: 1080px;
}

html,
body {
  height: 100%;
  -ms-scroll-chaining: none;
  overscroll-behavior: none;
  -webkit-user-drag: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
}

textarea,
button,
input,
select {
  -webkit-appearance: none;
  border-radius: 0;
  outline: none;
  border: 0;
}

li,
dd {
  list-style: none;
}

a {
  text-decoration: none;
}

table {
  border-collapse: collapse;
}

img {
  border: 0;
}

.clearfix {
  zoom: 1;
}

.clearfix:after {
  content: " ";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

[v-cloak] {
  display: none !important;
}

.font-red {
  color: #ef3939 !important;
}

.font-green {
  color: #1eac4e !important;
}

.ov {
  height: 100vh;
  overflow: hidden;
}

.flex {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.flex-item {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.flex-space-between {
  justify-content: space-between;
}

.flex-wrap {
  flex-wrap: wrap;
}

.main {
  position: relative;
  min-width: 900px;
  margin: auto;
}

.mod {
  background-repeat: no-repeat;
  background-position: center top;
  overflow: hidden;
}

.mod:first-child {
  background-image: url('../../assets/images/activity/activity20250301/bg-01.jpg');
  height: 590px;
}

.mod:nth-child(2) {
  background-image: url('../../assets/images/activity/activity20250301/bg-02.jpg');
  /* height: 800px; */
}

.mod:nth-child(3) {
  background-image: url('../../assets/images/activity/activity20250301/bg-03.jpg');
  height: 1126px;
}

.mod:nth-child(2) .mod-title {
  color: #333435;
  font-size: 56px;
  text-align: center;
  margin-top: 120px;
}

.mod:nth-child(2) .mod-info {
  color: #333435;
  font-size: 22px;
  margin-top: 120px;
  width: 900px;
  margin: auto;
}

.mod:nth-child(3) .mod-title {
  color: #fff;
  font-size: 56px;
  text-align: center;
  margin-top: 68px;
}

.mod:nth-child(3) .mod-info {
  color: #fff;
  font-size: 22px;
  margin-top: 120px;
  width: 900px;
  margin: auto;
}

.mod:nth-child(3) .mod-btn {
  background-image: url('../../assets/images/activity/activity20250301/btn-02.png');
}

.mod:nth-child(3) .mod-btn span {
  color: #323232;
}

.mod:nth-child(3) .mod-btn em {
  color: #d00;
}

.mod:nth-child(3) .mod-agreement {
  color: #fff;
}

.mod-banner {
  position: relative;
  width: 936px;
  margin: 56px auto;
}

.mod-banner::before {
  content: '';
  position: absolute;
  top: 31px;
  left: 0;
  width: 100%;
  height: 617px;
  border: 19px solid #eee6d6;
  box-sizing: border-box;
}

.swiper-container {
  width: 900px;
  margin: 0 auto;
  padding-top: 50px !important;
}

.swiper-wrapper > div {
  position: relative;
}

.mod-banner-title {
  position: absolute;
  top: -49px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #bc1002;
  text-align: center;
  width: 584px;
  height: 60px;
  z-index: 2;
}

.mod-banner-title::after, .mod-banner-title::before {
  content: '';
  position: absolute;
  top: 0;
  left: -30px;
  width: 0;
  height: 0;
  border-top: 30px solid transparent;
  border-bottom: 30px solid transparent;
  border-right: 30px solid #bc1002;
}

.mod-banner-title::after {
  left: auto;
  right: -30px;
  border-right: none;
  border-left: 30px solid #bc1002;
}

.mod-banner-title span {
  color: #fcf206;
  font-size: 32px;
}

.mod-banner .swiper-prev, .mod-banner .swiper-next {
  position: absolute;
  top: 50%;
  left: -22px;
  width: 52px;
  height: 52px;
  margin-top: -26px;
  background: url('../../assets/images/activity/activity20250301/prev.png') no-repeat;
  background-size: 100% auto;
  z-index: 1;
  cursor: pointer;
}

.mod-banner .swiper-next {
  left: auto;
  right: -22px;
  transform: rotateY(180deg);
}

.mod-banner .swiper-slide::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.mod-banner-title em {
  margin-left: 12px;
  font-size: 28px;
  color: #fff;
}

.mod-btn {
  position: relative;
  display: flex;
  justify-content: center;
  width: 730px;
  height: 90px;
  background: url('../../assets/images/activity/activity20250301/btn-01.png') no-repeat;
  background-size: 100% auto;
  margin: 50px auto 0;
  padding-top: 8px;
  text-align: center;
  cursor: pointer;
}

.mod-btn span {
  color: #fff;
  font-size: 40px;
}

.mod-btn em {
  font-size: 52px;
  color: #fff23e;
  vertical-align: bottom;
}

.mod-btn i {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: -52px;
  top: -24px;
  width: 186px;
  height: 58px;
  border-radius: 60px;
  color: #c21920;
  font-size: 26px;
  background: linear-gradient(to bottom, #fffeec 0, #fff10a 100%);
}

.mod-agreement {
  text-align: center;
  font-size: 12px;
  color: #777;
  margin: 10px 0 40px;
}

.mod-agreement a {
  color: #1997ff;
}

.card {
  justify-content: center;
  margin-top: 372px;
}

.card .item {
  width: 424px;
  height: 190px;
  background: url('../../assets/images/activity/activity20250301/card-bg.png') no-repeat;
  background-size: 100% auto;
  margin: 0 10px;
}

.card .item .content {
  padding: 10px 42px 0;
  height: 100px;
  justify-content: space-between;
}

.card .item sub {
  font-size: 20px;
  color: #f3132d;
  font-weight: bold;
}

.card .item span {
  font-size: 66px;
  color: #f3132d;
  font-weight: bold;
}

.card .item em {
  display: block;
  font-size: 22px;
  color: #313131;
  margin-top: 20px;
}

.card .item i {
  display: block;
  text-align: right;
  color: #f17a0e;
}

.card .item b {
  text-decoration: line-through;
}

.card .item .btn {
  background: linear-gradient(90deg, #ea0517 0, #fd1b2d 100%);
  width: 330px;
  height: 42px;
  margin: 15px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  color: #fff;
  text-align: center;
  border-radius: 30px;
  cursor: pointer;
}

.tips {
  color: #4b4b4b;
  font-size: 12px;
  padding: 40px 0;
  text-align: center;
  line-height: 2;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  z-index: 1;
}

.popup-main {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.zfcg {
  background: url('../../assets/images/activity/activity20250301/zfcg.png') no-repeat;
  background-size: 100% auto;
  width: 373px;
  height: 400px;
}

.zfcg .close {
  position: absolute;
  right: 0;
  top: 0;
  width: 60px;
  height: 60px;
  cursor: pointer;
}

.zfcg .icon {
  background: url('../../assets/images/activity/activity20250301/icon-success.png') no-repeat;
  background-size: 100% auto;
  width: 100px;
  height: 100px;
  margin: 78px auto 0;
}

.zfcg .text {
  margin-top: 26px;
  text-align: center;
  color: #333;
  font-size: 36px;
}

.zfcg .btns {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.zfcg .btns span {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  background-color: #f7522c;
  color: #fff;
  text-align: center;
  font-size: 28px;
  width: 174px;
  height: 54px;
  border-radius: 54px;
  cursor: pointer;
}



.jxzf {
  background: url('../../assets/images/activity/activity20250301/jxzf.png') no-repeat;
  background-size: 100% auto;
  width: 430px;
  height: 244px;
}

.jxzf .info {
  color: #d97844;
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
}

.jxzf .text {
  margin-top: 40px;
  text-align: center;
  color: #2b2b2b;
  font-size: 24px;
  font-weight: bold;
}

.jxzf .btns {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  padding: 0 40px;
}

.jxzf .btns span {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: #ebebeb;
  color: #262626;
  text-align: center;
  font-size: 18px;
  width: 164px;
  height: 49px;
  border-radius: 49px;
  cursor: pointer;
}

.jxzf .btns span:last-child {
  background: linear-gradient(to right, #efb290 0, #fbdabe 100%);
  color: #7c390f;
}

.gmcp {
  background: url('../../assets/images/activity/activity20250301/gmcp.png') no-repeat;
  background-size: 100% auto;
  width: 445px;
  height: 635px;
}

.gmcp .close {
  position: absolute;
  right: 0;
  top: 0;
  width: 60px;
  height: 60px;
  cursor: pointer;
}

.gmcp .title {
  text-align: center;
  margin-top: 50px;
}

.gmcp .title span {
  font-size: 23px;
  color: #4d0819;
}

.gmcp .title em {
  font-size: 26px;
  color: #1a1d20;
}

.gmcp .title b {
  font-size: 26px;
  color: #1a1d20;
  font-weight: bold;
}

.gmcp .qrcode {
  width: 256px;
  height: 256px;
  margin: 30px auto 0;
  overflow: hidden;
}

.gmcp .qrcode img {
  width: 100%;
}

.gmcp .tabs {
  display: flex;
  justify-content: center;
  margin-top: 26px;
}

.gmcp .tabs .item {
  position: relative;
  text-align: center;
  padding: 0 16px;
}

.gmcp .tabs .item::after {
  content: '';
  position: absolute;
  right: 0;
  top: 14px;
  border-left: 1px solid #e2b956;
  height: 36px;
}

.gmcp .tabs .item:last-child::after {
  display: none;
}

.gmcp .tabs .item > div {
  width: 64px;
  height: 64px;
  cursor: pointer;
  overflow: hidden;
}

.gmcp .tabs .item.active > div {
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
}

.gmcp .tabs .item i {
  display: block;
  margin: 14px auto 0;
  width: 18px;
  height: 18px;
  background-size: 100% auto;
  background-repeat: no-repeat;
}

.gmcp .tabs .item i.icon-wx {
  background-image: url('../../assets/images/activity/activity20250301/icon-wx.png');
}

.gmcp .tabs .item i.icon-zfb {
  background-image: url('../../assets/images/activity/activity20250301/icon-zfb.png');
}

.gmcp .tabs .item i.icon-qtzf {
  background-image: url('../../assets/images/activity/activity20250301/icon-qtzf.png');
}

.gmcp .tabs .item span {
  display: block;
  color: #777;
  font-size: 13px;
  margin-top: 4px;
}

.gmcp .foot {
  height: 144px;
  background-color: #fff;
  border-radius: 10px;
  padding: 25px 60px;
  margin-top: 30px;
  white-space: nowrap;
}

.gmcp .foot .zfje span {
  color: #777;
  font-size: 16px;
}

.gmcp .foot .zfje sub {
  color: #ad7d54;
  font-size: 16px;
  margin-left: 6px;
}

.gmcp .foot .zfje em {
  color: #ad7d54;
  font-size: 32px;
}

.gmcp .foot .zfje b {
  color: #ad7d54;
  font-size: 16px;
  text-decoration: line-through;
  margin-left: 6px;
}

.gmcp .foot .zfje i {
  display: inline-flex;
  align-items: center;
  color: #fff;
  font-size: 14px;
  text-decoration: line-through;
  background: linear-gradient(to right, #ff7a33 0, #ff157e 100%);
  height: 25px;
  padding: 0 6px;
  border-radius: 6px 0 6px 0;
  margin-left: 6px;
}

.gmcp .foot .xkxy {
  font-size: 12px;
  color: #777;
  margin-top: 10px;
}

.gmcp .foot .xkxy a {
  color: #1997ff;
}

.gmcp .foot .fpxx {
  color: #999;
  margin-top: 10px;
  font-size: 12px;
}

.gmcp .foot .fpxx a {
  color: #1997ff;
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activity20250302.vue